import { render } from "./EmailCard.vue?vue&type=template&id=1632602c&scoped=true"
import script from "./EmailCard.vue?vue&type=script&lang=js"
export * from "./EmailCard.vue?vue&type=script&lang=js"

import "./EmailCard.vue?vue&type=style&index=0&id=1632602c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1632602c"]])

export default __exports__